import { z } from 'zod';

import { LOS_MAX_LENGTH } from '../../constants';
import { getLOSBaseSchema } from '../../utils';

const baseSchema = getLOSBaseSchema(LOS_MAX_LENGTH);

export const EditLOSFormInput = z.object({
  los: baseSchema,
});

export type EditLOSFormValues = z.infer<typeof EditLOSFormInput>;
